import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import backend from "i18next-xhr-backend";
// import Backend from "i18next-http-backend";
import translationEN from "../locales/translationEN.json";
import { format as formatDate, isDate } from "date-fns";
import { IS_PROD } from "../constants";

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: !IS_PROD ? true : false,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: (value, format) => {
        if (isDate(value)) {
          if (format === "short") return formatDate(value, "P");
          if (format === "long") return formatDate(value, "PPPP");

          return formatDate(value, format || "P");
        }

        return value;
      },
    },
    resources: {
      en: {
        translation: translationEN,
      },
    },
  });

export default i18n;
